<div class="my-3 my-md-5">
    <div class="container">
    	<div class="page-header">
            <h1 class="page-title">
                <span *ngIf="!FeedbackId">Add OPD Feedback</span>
                <span *ngIf="FeedbackId">Update OPD Feedback</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="feedbackForm" (submit)="addFeedback()">
            	<div class="card-body patientDetailbox">
		            <div class="container-fluid p-3">
                        <h3><strong>Patient Information</strong></h3>
                        <div class="form-group">
		                    <div class="row">
                                <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Patient Name</label>
		                                <input class="form-control readonly" formControlName="pname" placeholder="Patient Name" readonly/>
		                            </div>
		                        </div>
                                <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Treatment</label>
		                                <input class="form-control readonly" formControlName="treatment" placeholder="Treatment" readonly/>
		                            </div>
		                        </div>
                                <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Doctor Name</label>
		                                <input class="form-control readonly" formControlName="docname" placeholder="Doctor Name" readonly/>
		                            </div>
		                        </div>
                                <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Hospital Name</label>
		                                <input class="form-control readonly" formControlName="hospitalname" placeholder="Hospital Name" readonly/>
		                            </div>
		                        </div>
                                <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Lead Owner Name</label>
		                                <input class="form-control readonly" formControlName="bd_name" placeholder="Lead Owner Name" readonly/>
		                            </div>
		                        </div>
                            </div>
                        </div>        
                    </div>
				</div>
                <div class="card-body">
		            <div class="container-fluid p-3">
                        <div class="form-group">
		                    <div class="row">
                                <div class="col-sm-12">
                                    <h3><strong>Rate the Patient Experience with Glamyo between 1 to 10</strong></h3>
                                </div>
                                <div class="col-sm-12">
                                    <h4>(1 being the lowest and 10 being the highest)</h4>
                                </div>
                                <div class="col-sm-7">
                                    <div class="form-group mb-5">
                                        <label class="form-label">1. How would you rate the behaviour and the helpfulness of Medical Counseller ?  </label>
                                        <div>
                                            <div class="chart-scale">
                                                <span class="" *ngFor="let q1 of [1,2,3,4,5,6,7,8,9,10]">
                                                <label class="scale-label">{{q1}}</label>
                                                <input type="radio"  value="{{q1}}" name="qone" class="btn btn-scale btn-scale-desc-{{q1}}" (click)="setRatingValue(q1,'medical_counseller_rating')">
                                                </span>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2 rating-input-box">
                                    Rated : <input class="rating-input readonly" type="text" id="medical_counseller_rating" formControlName="medical_counseller_rating" name="medical_counseller_rating" readonly>
                                </div>
                                <div class="col-sm-7">
                                    <div class="form-group mb-5">
                                        <label class="form-label">2. How would you rate the services of Clinic / Hospital Staff ?  </label>
                                        <div>
                                            <div class="chart-scale">
                                                <span class="" *ngFor="let q2 of [1,2,3,4,5,6,7,8,9,10]">
                                                <label class="scale-label">{{q2}}</label>
                                                <input  type="radio" value="{{q2}}" name="qtwo" class="btn btn-scale btn-scale-desc-{{q2}}" (click)="setRatingValue(q2,'hospital_service_rating')">
                                                </span>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2 rating-input-box">
                                    Rated : <input class="rating-input readonly" type="text" id="hospital_service_rating" name="hospital_service_rating" formControlName="hospital_service_rating" readonly>
                                </div>
                                <div class="col-sm-7">
                                    <div class="form-group mb-5">
                                        <label class="form-label">3. How would you rate the cleanliness and infrastructure of the clinic / hospital ?  </label>
                                        <div>
                                            <div class="chart-scale">
                                                <span class="" *ngFor="let q3 of [1,2,3,4,5,6,7,8,9,10]">
                                                <label class="scale-label">{{q3}}</label>
                                                <input type="radio" value="{{q3}}" name="qthree" class="btn btn-scale btn-scale-desc-{{q3}}" (click)="setRatingValue(q3,'hospital_cleanliness_rating')">
                                                </span>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2 rating-input-box">
                                    Rated : <input class="rating-input readonly" type="text" id="hospital_cleanliness_rating" name="hospital_cleanliness_rating" readonly formControlName="hospital_cleanliness_rating">
                                </div>
                                <div class="col-sm-7">
                                    <div class="form-group mb-5">
                                        <label class="form-label">4. How would you rate the treatment and diagnosis of Doctor ?  </label>
                                        <div>
                                            <div class="chart-scale">
                                                <span class="" *ngFor="let q4 of [1,2,3,4,5,6,7,8,9,10]">
                                                <label class="scale-label">{{q4}}</label>
                                                <input type="radio" value="{{q4}}" name="qfour" class="btn btn-scale btn-scale-desc-{{q4}}" (click)="setRatingValue(q4,'doctor_treatment_rating')">
                                                </span>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2 rating-input-box">
                                    Rated : <input class="rating-input readonly" type="text" id="doctor_treatment_rating" name="doctor_treatment_rating" formControlName="doctor_treatment_rating" readonly>
                                </div>
                                <div class="col-sm-7">
                                    <div class="form-group mb-5">
                                        <label class="form-label">5. How would you rate the overall experience with Glamyo health ?  </label>
                                        <div>
                                            <div class="chart-scale">
                                                <span class="" *ngFor="let q5 of [1,2,3,4,5,6,7,8,9,10]">
                                                <label class="scale-label">{{q5}}</label>
                                                <input type="radio" value="{{q5}}" name="qfifth" class="btn btn-scale btn-scale-desc-{{q5}}" (click)="setRatingValue(q5,'experience_with_glamyo_rating')">
                                                </span>
                                            </div> 
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2 rating-input-box">
                                    Rated : <input class="rating-input readonly" type="text" id="experience_with_glamyo_rating" name="experience_with_glamyo_rating" formControlName="experience_with_glamyo_rating" readonly>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Overall Rating</label>
		                                <input type="text" class="form-control" formControlName="overallrating" placeholder="Overall Rating" disabled/>
		                            </div>
		                        </div>
                                <div class="col-sm-3">
		                            <div class="form-group" style="margin-top: 10px;">
		                                <mat-form-field appearance="outline" class="followupDate">
                                            <mat-label>Date of Follow-Up</mat-label>
                                            <input matInput readonly formControlName="followupdate" [matDatepicker]="picker">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                        <div *ngIf="submitted && f.followupdate.errors" class="invalid-feedback">
                                            <div *ngIf="f.followupdate.errors.required">Follow-Up Date is required</div>
                                        </div>   
		                            </div>
                                    
		                        </div>
                                <div class="col-sm-3">
                                    <label class="form-label">Feedback Status *</label>
                                    <mat-select  placeholder="Status" formControlName="feedbackstatus">
                                        <mat-option [value]="1">Active</mat-option>
                                        <mat-option [value]="2">Follow-Up 1</mat-option>
                                        <mat-option [value]="3">Follow-Up 2</mat-option>
                                        <mat-option [value]="4">Not Received</mat-option>
                                        <mat-option [value]="5">Completed</mat-option>
                                        <mat-option [value]="6">OPD not Done</mat-option>
                                        <mat-option [value]="7">Closed</mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.feedbackstatus.errors" class="invalid-feedback">
                                        <div *ngIf="f.feedbackstatus.errors.required">Feedback Status is required</div>
                                    </div>
                                </div>
                                <div class="col-sm-3">
		                            <div class="form-group">
		                                <label class="form-label">Recording Link</label>
		                                <input type="text" formControlName="recodinglink" class="form-control" placeholder="Recording Link"/>
		                            </div>
		                        </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label class="form-label">Feedback Description</label>
                                        <textarea class="form-control" formControlName="description"></textarea>
                                    </div>
                                </div>
                            </div>    
                        </div>

                        <hr />
                        <div class="form-group">
		                    <div class="row">
                                <div class="col-sm-3">
                                    <label class="form-label">Number of Views :</label> 
                                    <input class="form-control" type="number" name="number_of_views" formControlName="number_of_views" > 
                                </div>
                                <div class="col-sm-3">
                                    <label class="form-label">Media Title :</label> 
                                    <input class="form-control" type="text" name="video_image_title" formControlName="video_image_title" > 
                                </div>
                                <div class="col-sm-3">
                                    <label class="form-label">Upload Before Surgery Image :</label> 
                                    <input type="file" (change)="selectMedia($event)" class="form-control" accept="image/*"/>
                                </div>
                                <div class="col-sm-3">
                                    <label class="form-label">Upload After Surgery Image :</label> 
                                    <input type="file" (change)="selectAfterMedia($event)" class="form-control" accept="image/*"/>
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
		                    <div class="row">
                                <div class="col-sm-3">
                                    <label class="form-label">Upload Video :</label> 
                                    <input type="file" (change)="selectVideoMedia($event)" class="form-control" accept="video/*"/>
                                </div>
                                <div class="col-sm-3">
                                    <label class="form-label">Media Approval Status :</label> 
                                    <mat-select  placeholder="Select Media Approval Status" formControlName="media_approval_status">
                                        <mat-option value="">Select Media Approval Status</mat-option>
                                        <mat-option [value]="1">Approved</mat-option>
                                        <mat-option [value]="2">Not Approved</mat-option>
                                    </mat-select>
                                </div>
                                <div class="col-sm-3">
                                    <div *ngIf="!fileDeletingLoader && image_url" class="list-group list-group-flush list-group-hoverable docList">
                                        <div class="row showfileblock align-items-center">
                                            <div class="col text-truncate">
                                                <a href="{{s3url}}{{image_url}}" target="_blank" class="text-body d-block">View File</a>
                                                <a *ngIf="myrole=='1' || myrole=='4'" class="delete-file float-right" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                                                        [cancelText]="cancelText" [placement]="placement" (confirm)="removeFile('image_link')" (cancel)="cancelClicked = true"
                                                        confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                                                        [appendToBody]="true"><i class="fa fa-trash text-danger"></i>
                                                </a>
                                                <i *ngIf="fileDeletingLoader" class="fa fa-spin fa-spinner float-right text-danger"></i>
                                                <small class="d-block text-muted text-truncate mt-n1">{{image_url}}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-sm-3">
                                    <div *ngIf="!fileDeletingLoader && after_image_url" class="list-group list-group-flush list-group-hoverable docList">
                                        <div class="row showfileblock align-items-center">
                                            <div class="col text-truncate">
                                                <a href="{{s3url}}{{after_image_url}}" target="_blank" class="text-body d-block">View File</a>
                                                <a *ngIf="myrole=='1' || myrole=='4'" class="delete-file float-right" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                                                        [cancelText]="cancelText" [placement]="placement" (confirm)="removeFile('after_surgery_image_link')" (cancel)="cancelClicked = true"
                                                        confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                                                        [appendToBody]="true"><i class="fa fa-trash text-danger"></i>
                                                </a>
                                                <i *ngIf="fileDeletingLoader" class="fa fa-spin fa-spinner float-right text-danger"></i>
                                                <small class="d-block text-muted text-truncate mt-n1">{{after_image_url}}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                
                            </div>
                        </div>
                        <div class="form-group">
		                    <div class="row">
                                <div class="col-sm-3">
                                    <div *ngIf="!fileDeletingLoader && video_url" class="list-group list-group-flush list-group-hoverable docList">
                                        <div class="row showfileblock align-items-center">
                                            <div class="col text-truncate">
                                                <a href="{{s3url}}{{video_url}}" target="_blank" class="text-body d-block">View File</a>
                                                <a *ngIf="myrole=='1' || myrole=='4'" class="delete-file float-right" mwlConfirmationPopover [popoverTitle]="popoverTitle" [popoverMessage]="popoverMessage" [confirmText]="confirmText"
                                                        [cancelText]="cancelText" [placement]="placement" (confirm)="removeFile('video_link')" (cancel)="cancelClicked = true"
                                                        confirmButtonType="danger" cancelButtonType="outline-secondary" (click)="confirmClicked = false; cancelClicked = false"
                                                        [appendToBody]="true"><i class="fa fa-trash text-danger"></i>
                                                </a>
                                                <i *ngIf="fileDeletingLoader" class="fa fa-spin fa-spinner float-right text-danger"></i>
                                                <small class="d-block text-muted text-truncate mt-n1">{{video_url}}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>                
				<div class="card-footer">
                    <button  type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> 
                        <span *ngIf="FeedbackId">Update Feedback</span>
                        <span *ngIf="!FeedbackId">Add Feedback</span>
                    </button>
                </div>
	        </form>
        </div>
    </div>
</div>
